import { mapGetters, mapMutations } from 'vuex';
import { getProductPriceTitle, PRODUCT_TYPE, resolveProductImage, routeToProduct } from '@/helpers';
import IconMinus from '@/components/icons/IconMinus.vue';
import IconPlus from '@/components/icons/IconPlus.vue';
import IconDelete from '@/components/icons/IconDelete.vue';
import product from '@/modules/Product';

export default {
  name: 'OrderBasketCard',
  components: { IconDelete, IconPlus, IconMinus },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    productType: {
      type: String,
      default: PRODUCT_TYPE.PRODUCT
    },
    syncPriceProductId: {
      type: [Number, null],
      default: null
    }
  },
  emits: ['update'],
  data() {
    return {
      PRODUCT_TYPE,
      isTrySyncPrice: false
    };
  },
  mounted() {},
  watch: {
    syncPriceProductId: {
      immediate: false,
      handler(newVal) {
        if (newVal === null && this.isTrySyncPrice) {
          this.isTrySyncPrice = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isSamplesLoading: 'samples/isSamplesLoading',
      isGiftsLoading: 'gifts/isGiftsLoading'
    }),
    isLoadingSyncProductPrice() {
      return this.syncPriceProductId === product.id || this.isTrySyncPrice;
    },
    isShowOldPrice() {
      if (this.isPromoProduct && this.product.discount) return true;
      if (this.product.select_type) {
        let { oldPrice, hasActivePromotion } = this.product.select_type;
        return oldPrice && (hasActivePromotion || this.product.discount);
      }
      return false;
    },

    isPromoProduct() {
      return this.productType === PRODUCT_TYPE.PROMO_PRODUCT;
    },

    isShowDiscountProduct() {
      return !!this.product.discount && !this.isPromoProduct;
    }
  },
  methods: {
    getProductPriceTitle,
    routeToProduct,
    resolveProductImage,
    ...mapMutations({
      increment: 'basket/INCREMENT_BASKET_LIST_COUNT',
      decrement: 'basket/DECREMENT_BASKET_LIST_COUNT',
      setCount: 'basket/SET_BASKET_LIST_COUNT',
      remove: 'basket/REMOVE_ITEM_FROM_BASKET',
      setRemovedSampler: 'samples/SET_REMOVED_SAMPLER'
    }),
    onRemove(product) {
      this.remove(product);
      this.$emit('update');
    },
    onRemoveSampler(id) {
      this.setRemovedSampler(id);
    },
    onChangeCount(type, count = 1) {
      this.isTrySyncPrice = true;
      if (type === 'increment') {
        this.increment(this.product);
      } else if (type === 'decrement') {
        this.decrement(this.product);
      } else {
        if (count) {
          this.setCount({
            product: this.product,
            select_count: parseInt(count)
          });
        }
      }
      this.$emit('update');
    }
  },

  beforeDestroy() {}
};
